/*global $*/
/*eslint no-undef: "error"*/
export default class FilterTop {
    classItem = 'filter-top--item'
    classButton = 'filter-top--button'
    classOpen = 'filter-blocks---open'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            $(this).closest(`.${self.classItem}`).toggleClass(self.classOpen)
        })
    }
}
